import utils from 'utils'
import printPage from './view/printPreview.html'
import submitResultPage from './view/submitResult.html'

class redInfoListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, dictService, sweetalert, redInfoService, initSortService, $timeout, invoiceOpenService, resultTipService, batchHandle) {
        // 初始化
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [{
                text: '批量提交',
                hasPermit: 'add_redInfo',
                handler() {
                    $scope.batchSubmitWorkflow()
                },
            }, {
                text: '批量打印',
                hasPermit: 'print_redInfoLis',
                handler() {
                    $scope.batchOpenPrintPreview()
                },
            }, {
                text: '批量上传税局',
                hasPermit: 'upload_tax_z',
                handler() {
                    $scope.batchUpLoadTaxStation()
                },
            }, {
                text: '批量开票',
                hasPermit: 'open_invoice_z',
                handler() {
                    $scope.batchOpen()
                },
            }, {
                text: '批量回退',
                hasPermit: 'back_redInfoList',
                handler() {
                    $scope.batchBack()
                },
            }],
        }
        const aMonth = utils.genPeriodByMonth()
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                applicant: '',
                blueInvoiceCodeOrNumber: '',
                custNameOrCreditCode: '',
                infoBeginDate: aMonth.start,
                infoEndDate: aMonth.end,
                infoStatus: '',
                invoiceStatus: '',
                workflowStatus: '',
                redInvoiceStatus: '',
                billCode: '',
                billBatchNo: '',
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                applicant: '',
                blueInvoiceCodeOrNumber: '',
                custNameOrCreditCode: '',
                infoBeginDate: aMonth.start,
                infoEndDate: aMonth.end,
                infoStatus: '',
                invoiceStatus: '',
                workflowStatus: '',
                redInvoiceStatus: '',
                billCode: '',
                billBatchNo: '',
            }
        }
        // $scope.reset()
        // 表头排序
        $scope.orderMap = initSortService('redInfoParam')
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('redInfoParam', JSON.stringify($scope.param))
            queryList()
        }
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.resData = []
        $scope.isOnSubmit = false
        $scope.isCollapsed = false // 批量下拉
        $scope.isCollapsed2 = false
        $scope.download = function () {
            window.open(`${host.etcloudOvat}dlTaskService/export_OVAT_RED_INFO?accessToken=${localStorage.id_token}`)
        }
        $scope.openImport = function (v) {
            if (!JSON.parse(localStorage.user_info).sale) {
                logger.logError('该机构未配置纳税人信息，不能进行该操作')
                return
            }
            $uibModal.open({
                templateUrl: './app/outputManage/fillOpenManage/ovatBill/view/ovatBillModalCtrl.html',
                controller: 'ovatBillModalCtrl',
                openedClass: 'et-ovat-bill-modal mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return {
                            code: v,
                        }
                    },
                },
            }).result.then(() => {
                queryList()
            })
        }
        $scope.customizedConfig = {
            version: 1.71,
            queryConfig: [{
                label: '申请日期',
                selected: true,
                default: true,
            }, {
                label: '购方名称/信用代码',
                selected: true,
                default: true,
            }, {
                label: '内部审核状态',
                selected: true,
                default: true,
            }, {
                label: '税局审核状态',
                selected: false,
                default: false,
            }, {
                label: '申请方',
                selected: false,
                default: false,
            }, {
                label: '蓝票代码',
                selected: false,
                default: false,
            }, {
                label: '是否开票',
                selected: false,
                default: false,
            }, {
                label: '红票代码/号码',
                selected: false,
                default: false,
            }, {
                label: '数据来源',
                selected: false,
                default: false,
            }, {
                label: '单据编号',
                selected: false,
                default: false,
            }, {
                label: '蓝票号码',
                selected: false,
                default: false,
            }, {
                label: '开票失败原因',
                selected: false,
                default: false,
            }, {
                label: '扩展1',
                selected: false,
                default: false,
            }, {
                label: '扩展2',
                selected: false,
                default: false,
            }, {
                label: '扩展3',
                selected: false,
                default: false,
            }],
            table: [{
                    label: '流水号',
                    selected: true,
                    default: true,
                }, {
                    label: '红字信息表编号',
                    selected: true,
                    default: true,
                }, {
                    label: '购方名称/信用代码',
                    selected: true,
                    default: true,
                },{
                    label: '购方地址电话',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方开户行及账号',
                    selected: false,
                    default: false,
                }, {
                    label: '合计金额/税额',
                    selected: true,
                    default: true,
                }, {
                    label: '价税合计',
                    selected: false,
                    default: false,
                }, {
                    label: '备注',
                    selected: false,
                    default: false,
                },{
                    label: '内部审核状态',
                    selected: true,
                    default: true,
                }, {
                    label: '税局审核状态',
                    selected: true,
                    default: true,
                }, {
                    label: '申请日期',
                    selected: true,
                    default: true,
                }, {
                    label: '关联销售单',
                    selected: false,
                    default: false,
                }, {
                    label: '单据编号',
                    selected: true,
                    default: true,
                }, {
                    label: '蓝票代码',
                    selected: false,
                    default: false,
                }, {
                    label: '蓝票号码',
                    selected: false,
                    default: false,
                }, {
                    label: '开票点',
                    selected: false,
                    default: false,
                }, {
                    label: '申请方',
                    selected: false,
                    default: false,
                }, {
                    label: '是否开票',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票失败原因',
                    selected: true,
                    default: true,
                }, {
                    label: '红票代码',
                    selected: false,
                    default: false,
                }, {
                    label: '数据来源',
                    selected: false,
                    default: false,
                }, {
                    label: '税局审核描述',
                    selected: false,
                    default: false,
                }, {
                    label: '红票号码',
                    selected: false,
                    default: false,
                }, {
                    label: '销方开户行及账号',
                    selected: false,
                    default: false,
                }, {
                    label: '扩展1',
                    selected: false,
                    default: false,
                }, {
                    label: '扩展2',
                    selected: false,
                    default: false,
                }, {
                    label: '扩展3',
                    selected: false,
                    default: false,
                }
            ],
        }
        $scope.selectedIdArr = []
        // 字典
        $scope.dictData = {}
        const typecodeArrStr = '["red_info_applicant","red_info_status","red_info_workflow_status","is_pass","inv_type","approve_status","bill_status","invoice_nature","tax_includ","is_privilege","zero_tax","is_list","invoice_status","yes_no_flag","red_info_source","red_invoice_status"]'
        const typecodeArr = ['red_info_applicant', 'red_info_status', 'red_info_workflow_status', 'is_pass', 'inv_type', 'approve_status', 'bill_status', 'invoice_nature', 'tax_includ', 'is_privilege', 'zero_tax', 'is_list', 'invoice_status', 'yes_no_flag', 'red_info_source', 'red_invoice_status']
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = res.data.value
            for (let i = 0, l = typecodeArr.length; i < l; i++) {
                const arr = $scope.dictData[typecodeArr[i]]
                arr.push({
                    enumTypeCode: null,
                    enumName: '全部',
                    enumCode: ''
                })
                arr.reverse()
                $scope.dictData[typecodeArr[i]] = arr
            }
            // 新增和编辑页面的申请人
            $scope.dictData.red_info_applicantinfo = $scope.dictData.red_info_applicant.slice(1)
        })
        // 分别 是否开票、工作流状态、税局审核状态
        const dictArr = ['red_invoice_status', 'red_info_workflow_status', 'red_info_status', 'red_info_source']
        dictService.getAndCache(dictArr).then((res) => {
            Object.assign($scope.dictData, res)
        })

        function queryList() {
            $scope.param = sessionStorage.redInfoParam ? JSON.parse(sessionStorage.redInfoParam) : $scope.param
            const openLoading = $scope.param.pageSize >= 100 ? window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            }) : null
            httpRequest.post_getPageRedInfoList($scope.param).then((res) => {
                $scope.isOnSubmit = true
                $scope.selectedIdArr = []
                $scope.resData = res.data.value.list
                $scope.param.pageNum = res.data.value.pageNum
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total
            }).finally(() => {
                window.layer.close(openLoading)
            })
        }
        /**
         * 提交
         * @param  {object} redInfoItem 红字信息表对象
         * @param  {string} ukeyId      开票点ID
         */
        function submitWorkFlow(redInfoItem, ukeyId) {
            utils.loading('提交中...')
            redInfoItem.ukeyId = ukeyId
            httpRequest.post_submitWorkflow({
                infoIdArray: redInfoItem.infoId,
                ukeyId,
            }).then((res) => {
                if (res.data.value.error === 0) {
                    logger.logSuccess('提交成功')
                } else {
                    logger.logError(res.data.value.messageList[0].errorMsg)
                }
                queryList()
                utils.loaded()
            })
        }

        // 打印
        function printRedInfo(info) {
            const infoModalData = info // 数据
            const modalInstance = $uibModal.open({
                template: printPage,
                controller: 'modalPrintCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-print mod-modal mod-modal-lg',
                resolve: {
                    items1() {
                        return infoModalData
                    },
                    items2() {
                        return $scope.dictData
                    },
                },
            })
            modalInstance.result.then((item) => {
                console.log(item)
            }, () => {
                console.log(`Modal dismissed at: ${new Date()}`)
                return false
            })
        }
        // 判断是否含某种状态数据
        function hasSomeWorkflowStatus(arr, oldid, s) {
            const selectedArr = []
            const o = arr
            let fl = false
            for (const m in o) {
                if (o[m].hasOwnProperty(oldid) && o[m][oldid] && o[m].workflowStatus === s) {
                    fl = true
                    break
                }
            }
            return fl
        }
        // 是否符合提交发票要求
        function hasWorkflowStatusArr(arr, oldid) {
            const selectedArr = []
            const o = arr
            let fl = false
            for (const m in o) {
                if (o[m].hasOwnProperty(oldid) && o[m][oldid] && o[m].workflowStatus !== '0' && o[m].workflowStatus !== '4') {
                    fl = true
                    break
                }
            }
            return fl
        }

        $scope.pageChanged = function () { // 点击页码发起查询
            queryList()
        }

        // 返回开票点名称
        $scope.filterUkeyName = function (id) {
            if (id === null) {
                return id
            }
            const fliterUkeyNameArr = $scope.userInfo.sysUkeyList.filter((item) => item.ukeyId === id)
            if (fliterUkeyNameArr.length > 0) {
                return fliterUkeyNameArr[0].ukeyName
            }
            return id
        }
        httpRequest.get_getUserCustomized(3).then(res => {
            if (res.data.value) {
                let orderMap = JSON.parse(res.data.value).orderMap
                if (orderMap) {
                    $scope.orderMap = orderMap
                }
            }
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) {
                $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            }
            sessionStorage.setItem('redInfoParam', JSON.stringify($scope.param))
            queryList()
        })
        // 分页跳转
        $scope.pageChanged = function pageChanged() { // 点击页码发起查询
            sessionStorage.setItem('redInfoParam', JSON.stringify({
                orderMap: $scope.param.orderMap,
                pageNum: $scope.param.pageNum,
                pageSize: $scope.param.pageSize,
                param: sessionStorage.redInfoParam ? JSON.parse(sessionStorage.redInfoParam).param : {
                    applicant: '',
                    blueInvoiceCodeOrNumber: '',
                    custNameOrCreditCode: '',
                    infoBeginDate: aMonth.start,
                    infoEndDate: aMonth.end,
                    infoStatus: '',
                    invoiceStatus: '',
                    workflowStatus: '',
                    redInvoiceStatus: '',
                    billCode: '',
                    billBatchNo: '',
                },
            }))
            queryList()
        }
        $scope.searchList = function searchList() {
            sessionStorage.setItem('redInfoParam', JSON.stringify($scope.param))
            queryList()
        }

        function getVisiableStatusByKey(item, key) {
            return item.redAuthorityList
        }
        /*
            税局审核状态（infoStatus）字典

            空
            审核通过："TZD0000"
            待上传："TZD0500"
            重复上传 TZD0061
            待查证 TZD0071
            已核销,待查证：TZD0072
            已核销,查证未通过,待处理：TZD0073
            已核销：TZD0074
            核销后激活：TZD0075

            审核状态(workflowStatus) 字典

            待提交：0
            暂存：-1
            审核中：1
            审核不通过：2
            审核通过：3
            被回退：4
        */
        $scope.tableDropdownConfig = [{
            label: '详情',
            handler(item) {
                // $state.go('outputManage.FOManage.redInfo.detail', { infoId: item.infoId })
                const url = $state.href('outputManage.FOManage.redInfo.detail', {
                    infoId: item.infoId,
                }, {
                    reload: true,
                })
                window.open(url, '_blank')
            },
            showWhile() {
                return true
            },
        }, {
            label: '打印预览',
            handler(item) {
                if (!item.infoId) {
                    logger.logError('红字信息行信息有误！')
                    return
                }
                httpRequest.get_getOvatRedInfoById({
                    infoId: item.infoId,
                }).then((res) => {
                    if (!res.data.success) {
                        logger.logError(res.data.message)
                        return
                    }
                    const balanceModalData = []
                    balanceModalData.push(res.data.value) // 数据
                    printRedInfo(balanceModalData)
                })
            },
            showWhile(item, hasPermit) {
                return hasPermit('print_redInfoLis') && item.authMap.PRINT_PREVIEW
            },
        }, {
            label: '编辑',
            handler(item) {
                $state.go('outputManage.FOManage.redInfo.edit', {
                    infoId: item.infoId,
                })
            },
            showWhile(item, hasPermit) {
                return hasPermit('add_redInfo') && item.authMap.RED_EDIT
            },
        }, {
            label: '提交',
            handler(item) {
                if (!item.infoId) {
                    logger.logError('红字信息行信息有误！')
                    return
                }
                // 如果有开票点直接提交
                if (item.ukeyId) {
                    submitWorkFlow(item, item.ukeyId)
                    return
                }
                // 负数发票修改开票点
                const modalInstance = $uibModal.open({
                    templateUrl: 'redInfoChangeUkeyModalCtrl.html',
                    controller: 'redInfoChangeUkeyModalCtrl',
                    openedClass: 'mod-modal mod-modal-lg',
                    backdrop: 'static',
                })
                modalInstance.result.then((ukeyId) => {
                    submitWorkFlow(item, ukeyId)
                })
            },
            showWhile(item, hasPermit) {
                return hasPermit('upload_tax_z') && item.authMap.RED_SUBMIT_REVIEW
            },
        }, {
            label: '回退',
            handler(item) {
                if (!item.infoId) {
                    logger.logError('红字信息行信息有误！')
                    return
                }
                sweetalert.swal({
                    title: '操作提醒',
                    text: '您正在进行回退红字信息表的操作，确定要回退信息表吗？',
                    // type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: '#0096e7',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }, (isConfirm) => {
                    if (isConfirm) {
                        httpRequest.post_reductionOvatRedInfo(item.infoId, '回退成功').then(() => {
                            $timeout(() => {
                                queryList()
                            }, 800)
                        })
                    }
                })
            },
            showWhile(item, hasPermit) {
                return hasPermit('back_redInfoList') && item.authMap.RED_FALLBACK
            },
        }, {
            label: '上传',
            handler(item) {
                if (!item.infoId) {
                    logger.logError('红字信息行信息有误！')
                    return
                }
                // if (checkSoapBeforeTaxCore()) return
                utils.loading('正在上传, 请稍候')
                if (!item.ukeyId && item.ukeyId !== 0) {
                    const ukeyList = JSON.parse(localStorage.user_info).sysUkeyList
                    const ukey = ukeyList.filter(i => {
                        return i.diskCode == localStorage.currentDiskCode && i.manageType == '0'
                    })
                    if (ukey.length) {
                        item.ukeyId = ukey[0].ukeyId
                    } else {
                        item.ukeyId = ukeyList[0].ukeyId
                    }
                }
                redInfoService.upload([item.infoId], item.ukeyId).then(() => {
                    logger.logSuccess('上传成功')
                }, (err) => {
                    logger.logError(err)
                }).finally(() => {
                    $timeout(() => {
                        queryList()
                    }, 800)
                    utils.loaded()
                })
            },
            showWhile(item, hasPermit) {
                return hasPermit('upload_tax_z') && item.authMap.RED_UPLOAD
            },
        }, {
            label: '删除',
            handler(item) {
                const msg = '确认删除此红字信息表'
                sweetalert.swal({
                    title: '删除提醒',
                    text: msg,
                    // type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: '#0096e7',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }, (isConfirm) => {
                    if (isConfirm) {
                        // 确定处理
                        httpRequest.post_delRedInfo({
                            infoId: item.infoId,
                        }).then(() => {
                            $timeout(() => {
                                queryList()
                            }, 800)
                        })
                    }
                })
            },
            showWhile(item, hasPermit) {
                return hasPermit('del_redInofList') && item.authMap.RED_DELETE
            },
        }, {
            label: '输入编号',
            handler(info) {
                if (info.infoCode !== '' && info.infoCode != null) {
                    logger.logError('编号已存在！')
                    return
                }
                const inserInfoNoData = {} // 数据
                const modalInstance = $uibModal.open({
                    template: require('./view/inserInfoNoView.html'),
                    controller: 'inserInfoNoCtrl',
                    openedClass: 'mod-modal mod-modal-md',
                    backdrop: 'static',
                    resolve: {
                        items1() {
                            return inserInfoNoData
                        },
                    },
                })
                modalInstance.result.then((item) => {
                    // 获取单条信息
                    const req = {
                        infoCode: item.infoCodeNo,
                        infoId: info.infoId,
                        infoStatus: info.infoStatus,
                    }
                    httpRequest.post_updateCodeSaveInvoiceWait(req).then((res) => {
                        if (!res.data.success) {
                            logger.logError(res.data.message)
                            return
                        }
                        logger.logSuccess('提交成功')
                        info.infoCode = item.infoCodeNo
                        $timeout(() => {
                            queryList()
                        }, 800)
                        // $scope.resData.splice($index, 1);
                    })
                })
            },
            showWhile(item, hasPermit) {
                return hasPermit('get_redInfoCode') && item.authMap.RED_INPUT_NUMBER
            },
        }, {
            label: '开票',
            handler(item) {
                $state.go('outputManage.FOManage.redInfo.opened', {
                    invType: '0',
                    infoId: item.infoId,
                })
            },
            showWhile(item, hasPermit) {
                return item.authMap.RED_INVOICE && hasPermit('open_invoice_z')
            },
        }]

        function openBatchSubmitResult(result) {
            $uibModal.open({
                template: submitResultPage,
                controller: ['$scope', 'items1', '$uibModalInstance', function ctrl(scope, items1, $uibModalInstance) {
                    scope.errorList = items1
                    scope.close = function close() {
                        $uibModalInstance.close()
                    }
                }],
                openedClass: 'mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return result
                    },
                },
            }).result.then(() => {
                queryList()
            })
        }
        // 批量提交
        $scope.batchSubmitWorkflow = function batchSubmitWorkflow() {
            const infoIdArr = $scope.selectedIdArr.map((x) => x.infoId)
            if (infoIdArr.length === 0) {
                logger.logError('请先选择信息行')
                return
            }
            // 不能提交的行号
            let redInfo
            for (let i = 0; i < $scope.resData.length; i++) {
                redInfo = $scope.resData[i]
                if (redInfo.selected && !redInfo.authMap.RED_SUBMIT_REVIEW) {
                    logger.logError('只有内部审核状态为待提交、审核不通过、被回退且未上传过税局的申请表才允许提交审核')
                    return
                }
            }
            const infoIds = infoIdArr.join(',')
            batchHandle.open().then(data => {
                utils.loading('系统正在批量处理中，请耐心等待...')
                if (data.startRow || data.endRow) {
                    const subParams = $.extend(data, $scope.param)
                    httpRequest.post_submitWorkflowRange(subParams).then(res => {
                        submitCallback(res)
                    })
                } else {
                    httpRequest.post_submitWorkflow({
                        infoIdArray: infoIds,
                    }).then((res) => {
                        submitCallback(res)
                    })
                }
            })
        }

        // 批量回退
        $scope.batchBack = function batchBack() {
            const infoIdArr = $scope.selectedIdArr.map((x) => x.infoId)
            if (infoIdArr.length === 0) {
                logger.logError('请先选择信息行')
                return
            }
            const arr = $scope.selectedIdArr.filter(i => {
                return !i.authMap.RED_FALLBACK
            })
            if (arr.length) {
                logger.logError('存在不能回退的红字信息表，请重新选择')
                return
            }

            sweetalert.swal({
                title: '操作提醒',
                text: `您当前选中${$scope.selectedIdArr.length}条数据，回退后需要重新提交检测，确认回退吗？`,
                // type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#0096e7',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnConfirm: true,
                closeOnCancel: true,
            }, (isConfirm) => {
                if (isConfirm) {
                    utils.loading('系统正在批量处理中，请耐心等待...')
                    httpRequest.post_batchReductionOvatRedInfo(infoIdArr).then((res) => {
                        utils.loaded()
                        if (res.data.value.error) {
                            const params = {
                                sourceCount: res.data.value.total,
                                errorCount: res.data.value.error,
                                list: res.data.value.messageList,
                                title: '回退'
                            }
                            resultTipService.openErrorModal(params, queryList)
                        } else {
                            logger.logSuccess(`回退成功${res.data.value.total}张票据`)
                            queryList()
                        }
                    }, () => {
                        utils.loaded()
                    })
                }
            })
        }
        function submitCallback(res) {
            utils.loaded()
            if (res.data.value.error) {
                const params = {
                    sourceCount: res.data.value.total,
                    errorCount: res.data.value.error,
                    list: res.data.value.messageList,
                    title: '提交'
                }
                resultTipService.openErrorModal(params, queryList)
            } else {
                logger.logSuccess(`提交成功${res.data.value.total}张票据`)
                queryList()
            }
        }
        // 批量打印
        $scope.batchOpenPrintPreview = function batchOpenPrintPreview() {
            const infoIdArr = $scope.selectedIdArr.map((x) => x.infoId)
            if (infoIdArr.length == 0) {
                logger.logError('请先选择信息行')
                return
            }
            const infoIds = infoIdArr.join(',')
            httpRequest.post_getRedInfoListByIds({
                infoIdArray: infoIds,
            }).then((res) => {
                // 回掉
                if (!res.data.success) {
                    logger.logError(res.data.message)
                    return
                }
                // 打印
                const infoResArray = res.data.value
                const infoResArrayLen = infoResArray.length
                printRedInfo(infoResArray)
            })
        }


        // 下载
        $scope.openDownLoad = function (size) {
            const modalInstance = $uibModal.open({
                template: require('./view/downLoadPageContent.html'),
                controller: 'downLoadPageCtrl',
                openedClass: 'mod-modal-download mod-modal mod-modal-hg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return {}
                    },
                },
            })
            modalInstance.result.then((item) => {
                console.log(item)
                queryList()
            }, () => {
                console.log(`Modal dismissed at: ${new Date()}`)
            })
        }
        // 批量上传税局
        $scope.batchUpLoadTaxStation = function batchUpLoadTaxStation() {
            const infoIdArr = $scope.selectedIdArr.map((x) => x.infoId)
            const infoIdArrLen = infoIdArr.length
            if (infoIdArrLen === 0) {
                logger.logError('请先选择红字信息表行')
                return
            }
            const arr = $scope.selectedIdArr.filter(i => {
                return !i.authMap.RED_UPLOAD
            })
            if (arr.length) return logger.logError('存在不能上传红字信息表，请重新选择')
            $uibModal.open({
                templateUrl: 'chooseUkey.html',
                controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                    const diskList = JSON.parse(localStorage.user_info).sysUkeyList
                    $scope.diskList = [diskList[0]]
                    diskList.forEach(disk => {
                        let flag = true
                        $scope.diskList.forEach(i => {
                            if (disk.diskCode == i.diskCode) flag = false
                        })
                        flag && $scope.diskList.push(disk)
                    })
                    $scope.disk = $scope.diskList[0]
                    $scope.ok = () => {
                        $uibModalInstance.close($scope.disk)
                    }
                    $scope.cancel = () => {
                        $uibModalInstance.dismiss()
                    }
                }],
                openedClass: 'mod-modal mod-modal-md',
                backdrop: 'static',
            }).result.then((ukey) => {
                console.log(ukey)
                const msg = `您正在上传${infoIdArrLen}张红字信息表至税局审核，操作完成前，请确保您的网络连接正常，以免造成红字信息表编号丢失。`

                sweetalert.confirm('批量上传税局', msg).then(() => {
                    utils.loading('正在上传, 请稍候')
                    redInfoService.upload(infoIdArr, ukey.ukeyId).then((result) => {
                        logger.logSuccess(result)
                    }, (err) => {
                        logger.logError(err)
                    }).finally(() => {
                        $timeout(() => {
                            queryList()
                        }, 800)
                        utils.loaded()
                    })
                })
            })
        }
        $scope.dropdown_rowhover_state = function (row, flag) {
            row.dropdowstatenhover = flag
        }
        // 销售单明细
        $scope.toCheckPage = function (item) {
            if (item.billId === undefined || item.billId === null || item.billId === '') {

            } else {
                // $state.go('outputManage.FOManage.redInfo.checkBillDetail', { billId: item.billId })
                const url = $state.href('outputManage.FOManage.redInfo.checkBillDetail', {
                    billId: item.billId,
                }, {
                    reload: true,
                })
                window.open(url, '_blank')
            }
        }
        // 批量红冲验证
        $scope.batchOpenValidate = function (selectedList) {
            const selectedListLen = selectedList.length
            if (selectedListLen == 0) {
                logger.logError('请先选择红字信息表行')
                return false
            }
            const isOpened = selectedList.some((a) => a.redInvoiceStatus == '2')
            if (isOpened) {
                logger.logError('您选择的数据中存在“已开票”的数据，请重新选择')
                return false
            }
            const emptyInfoCode = selectedList.some((a) => a.infoCode == '')
            const approveInvoice = selectedList.some((a) => a.infoStatus != 'TZD0000')
            if (emptyInfoCode || approveInvoice) {
                logger.logError('您选择的数据中存在税局审核状态未通过或红字信息表编码为空，请先提交上传税局审核通过后再进行开票')
                return false
            }
            // if (invoiceOpenService.chechManageTypeDiff(selectedList)) {
            //     logger.logError('您选择的发票开票点不是同一个类型的，请重新选择')
            //     return false
            // }
            return true
        }
        $scope.batchOpen = function () {
            if (!$scope.batchOpenValidate($scope.selectedIdArr)) {
                return
            }
            $uibModal.open({
                templateUrl: './app/outputManage/fillOpenManage/ovatBill/view/ovatBillModalCtrl.html',
                controller: 'ovatBillModalCtrl',
                openedClass: 'et-ovat-bill-modal mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return {
                            code: 'redBatchOpen',
                        }
                    },
                },
            }).result.then((ukeyId) => {
                $scope.selectedIdArr.forEach(invoice=>{
                    invoice.ukeyId = ukeyId
                })
                $uibModal.open({
                    templateUrl: 'redInfoBatchOpen.html',
                    controller: ['$scope', '$uibModalInstance', 'items1', 'logger', 'invoiceOpenService', function ($scope, $uibModalInstance, items1, logger, invoiceOpenService) {
                        // 批量开票
                        function openBatch(invoiceList, type) {
                            function successCallback(errorInvoiceIds) {
                                utils.loaded()
                                const len = invoiceList.length
                                const errorNum = errorInvoiceIds.length
                                logger.logMsg({
                                    title: '操作结果',
                                    icon: 1,
                                    message: `共计${len}张发票,成功${len - errorNum}张，失败${errorNum}张！`,
                                })
                                queryList()
                                if (errorNum && !type) {
                                    httpRequest.post_openingFailedBackWrite(errorInvoiceIds).then(() => {
                                        queryList()
                                    })
                                }
                            }

                            function errorCallback() {
                                utils.loaded()
                            }

                            function notifyCallback(currentIndex = 0) {
                                const currentInvoice = invoiceList[currentIndex]
                                utils.loading(`正在开具第${currentIndex + 1}张发票`)
                            }
                            const API = type ? 'a9OpenBatch' : 'scanOpenBatch'
                            invoiceOpenService[API](invoiceList, true).then(
                                successCallback,
                                errorCallback,
                                notifyCallback,
                            ).finally(() => {
                                utils.loaded()
                            })
                        }

                        // 批量开票打印
                        function openPrintBatch(invoiceList, diskInfo = {}) {
                            if (invoiceOpenService.chechManageTypeDiff(invoiceList)) {
                                logger.logError('您选择的发票开票点不是同一个类型的，请重新选择')
                                return
                            }
                            const len = invoiceList.length

                            function successCallback(errorNum) {
                                utils.loaded()
                                logger.logMsg({
                                    title: '操作结果',
                                    icon: 1,
                                    message: `共计${len}张发票,成功${len - errorNum}张，失败${errorNum}张！`,
                                })
                                queryList()
                            }

                            function errorCallback(error) {
                                utils.loaded()
                                logger.logError(error.retmsg)
                                httpRequest.post_openingFailedBackWrite([error.waitId]).then(() => {
                                    queryList()
                                })
                                setTimeout(() => {
                                    logger.logMsg({
                                        title: '操作结果',
                                        icon: 1,
                                        message: `共计${len}张发票,成功${len - error.errorNum}张，失败${error.errorNum}张！`,
                                    })
                                }, 1500)
                            }

                            function notifyCallback(currentIndex) {
                                const currentInvoice = invoiceList[currentIndex]
                                utils.loaded()
                                utils.loading(`正在开具第${currentIndex + 1}张发票`)
                            }
                            invoiceOpenService.openPrintBatchBackID(invoiceList, diskInfo.taxCode, diskInfo.machinNo).then(
                                successCallback,
                                errorCallback,
                                notifyCallback,
                            ).finally(() => {
                                utils.loaded()
                            })
                        }
                        $scope.modaldata = {
                            invoiceIds: [],
                            type: -1,
                        }
                        $scope = $.extend($scope, items1)
                        $scope.invoiceList = items1
                        $scope.totalMoney = 0
                        $scope.totalTax = 0
                        $scope.invoiceList.forEach((element) => {
                            $scope.totalMoney += element.totalAmt
                            $scope.totalTax += element.totalTaxamt
                        })

                        // 关闭
                        $scope.cancel = function cancel() {
                            $uibModalInstance.dismiss('cancel')
                        }
                        // 确定
                        $scope.ok = function ok(type) {
                            const infoIds = $scope.invoiceList.map((x) => x.infoId)
                            const ukey = JSON.parse(localStorage.user_info).sysUkeyList.filter(u => {
                                return u.ukeyId == $scope.invoiceList[0].ukeyId
                            })
                            let obj = {
                                infoIds: infoIds,
                                ukeyCode: ukey[0].ukeyCode,
                                diskCode: ukey[0].diskCode
                            }
                            if (invoiceOpenService.checkIsA9($scope.invoiceList[0].ukeyId)) {
                                for (let i = 0; i < $scope.invoiceList.length; i++) {
                                    if (!$scope.invoiceList[i].custAddress || !$scope.invoiceList[i].custBank) return logger.logError(`蓝票号码${$scope.invoiceList[i].blueInvoiceNumber}购方地址/电话、开户行及账号不能为空，请通过单条开票进行信息完善`)
                                }
                                if (type) {
                                    sweetalert.confirm('操作提醒', '批量开票完成后将自动执行批量打印操作，若存在多个发票号段，易出现纸质票与需打印的发票电子信息不一致的情况，请检查好可供开具的空白发票号段与打印机上的空白纸质发票是否一致，谨慎操作！').then(() => {
                                        utils.loading('开票打印中')
                                        httpRequest.post_batchOpeningRedInfo(obj).then((res) => {
                                            if (res.data.success && res.data.value) {
                                                httpRequest.post_lockOvatRedInfo({
                                                    infoIds,
                                                    isLock: 1,
                                                }).then(() => {
                                                    const invoiceDTOs = res.data.value
                                                    // invoiceOpenService.checkWithDiskInfo(invoiceDTOs).then((diskIfno) => {
                                                    openPrintBatch(invoiceDTOs)
                                                    // }, (err) => {
                                                    //     logger.logError(err)
                                                    // })
                                                }).finally(() => {
                                                    httpRequest.post_lockOvatRedInfo({
                                                        infoIds,
                                                        isLock: '0',
                                                    }).then(() => {
                                                        $uibModalInstance.dismiss('ok')
                                                    })
                                                })
                                            }
                                        }, () => {
                                            $uibModalInstance.dismiss('ok')
                                        })
                                    })
                                } else {
                                    sweetalert.confirm('操作提醒', `当前执行批量开票的单据份数为${infoIds.length}张，请确认`).then(() => {
                                        utils.loading('开票中')
                                        httpRequest.post_batchOpeningRedInfo(obj).then((res) => {
                                            if (res.data.success && res.data.value) {
                                                httpRequest.post_lockOvatRedInfo({
                                                    infoIds,
                                                    isLock: 1,
                                                }).then(() => {
                                                    const invoiceDTOs = res.data.value
                                                    openBatch(invoiceDTOs, 2)

                                                }).finally(() => {
                                                    httpRequest.post_lockOvatRedInfo({
                                                        infoIds,
                                                        isLock: '0',
                                                    }).then(() => {
                                                        $uibModalInstance.dismiss('ok')
                                                    })
                                                    // httpRequest.post_openingFailedBackWrite(infoIds)
                                                })
                                            }
                                        }, () => {
                                            $uibModalInstance.dismiss('ok')
                                        })
                                    })
                                }
                            } else {
                                redInfoService.getCurrentDiskId().then((diskInfo) => {
                                    if (diskInfo) {
                                        let obj = {
                                            infoIds: infoIds,
                                            ukeyCode: diskInfo.MachineNo,
                                            diskCode: diskInfo.kpfwqh
                                        }
                                        for (let i = 0; i < $scope.invoiceList.length; i++) {
                                            if (!$scope.invoiceList[i].custAddress || !$scope.invoiceList[i].custBank) return logger.logError(`蓝票号码${$scope.invoiceList[i].blueInvoiceNumber}购方地址/电话、开户行及账号不能为空，请通过单条开票进行信息完善`)
                                        }
                                        if (type) {
                                            sweetalert.confirm('操作提醒', '批量开票完成后将自动执行批量打印操作，若存在多个发票号段，易出现纸质票与需打印的发票电子信息不一致的情况，请检查好可供开具的空白发票号段与打印机上的空白纸质发票是否一致，谨慎操作！').then(() => {
                                                utils.loading('开票打印中')
                                                httpRequest.post_batchOpeningRedInfo(obj).then((res) => {
                                                    if (res.data.success && res.data.value) {
                                                        httpRequest.post_lockOvatRedInfo({
                                                            infoIds,
                                                            isLock: 1,
                                                        }).then(() => {
                                                            const invoiceDTOs = res.data.value
                                                            invoiceOpenService.checkWithDiskInfo(invoiceDTOs).then((diskIfno) => {
                                                                openPrintBatch(invoiceDTOs, diskIfno)
                                                            }, (err) => {
                                                                logger.logError(err)
                                                            })
                                                        }).finally(() => {
                                                            httpRequest.post_lockOvatRedInfo({
                                                                infoIds,
                                                                isLock: '0',
                                                            }).then(() => {
                                                                $uibModalInstance.dismiss('ok')
                                                            })
                                                        })
                                                    }
                                                }, () => {
                                                    $uibModalInstance.dismiss('ok')
                                                })
                                            })
                                        } else {
                                            sweetalert.confirm('操作提醒', `当前执行批量开票的单据份数为${infoIds.length}张，请确认`).then(() => {
                                                utils.loading('开票中')
                                                httpRequest.post_batchOpeningRedInfo(obj).then((res) => {
                                                    if (res.data.success && res.data.value) {
                                                        httpRequest.post_lockOvatRedInfo({
                                                            infoIds,
                                                            isLock: 1,
                                                        }).then(() => {
                                                            const invoiceDTOs = res.data.value

                                                            invoiceOpenService.checkWithDiskInfo(invoiceDTOs).then((diskIfno) => {
                                                                openBatch(invoiceDTOs)
                                                            }, (err) => {
                                                                logger.logError(err)
                                                            })
                                                        }).finally(() => {
                                                            httpRequest.post_lockOvatRedInfo({
                                                                infoIds,
                                                                isLock: '0',
                                                            }).then(() => {
                                                                $uibModalInstance.dismiss('ok')
                                                            })
                                                            // httpRequest.post_openingFailedBackWrite(infoIds)
                                                        })
                                                    }
                                                }, () => {
                                                    $uibModalInstance.dismiss('ok')
                                                })
                                            })
                                        }
                                    } else {
                                        logger.logError("获取金税盘信息失败")
                                    }
                                }, (err) => {
                                    logger.logError(err)
                                })
                            }
                        }
                    }],
                    backdrop: 'static',
                    openedClass: 'mod-modal-haslist mod-modal mod-modal-lg mod-modal-batchred mod-modal-batchred-large-width',
                    resolve: {
                        items1() {
                            return $scope.selectedIdArr
                        },
                    },
                }).result.then().finally(() => {
                    queryList()
                })
            })
        }
    }
}

redInfoListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'dictService', 'sweetalert', 'redInfoService', 'initSortService', '$timeout', 'invoiceOpenService', 'resultTipService', 'batchHandle']
export default redInfoListCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/redInfoListCtrl.js